import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class ShareItemsService {
  constructor(private apiService: ApiService) {}

  getUserGroups(userId: number): Observable<any> {
    return this.apiService.get<any>(`/v1/users/${userId}/groups`);
  }
  updateResourceGroupMemberships(resource_path: string, resource_ids: number[], group_ids: number[]): Observable<any> {
    const endpoint = `/v1/${resource_path}/groups`;
    const body = {
      resource_ids,
      group_ids,
    };
    return this.apiService.patch<any>(endpoint, body);
  }
  removeResourceFromGroup(resource_path: string, itemId: number, groupId: number): Observable<any> {
    const endpoint = `/v1/${resource_path}/${itemId}/groups/${groupId}`;
    return this.apiService.delete<any>(endpoint);
  }
}
